import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import LxScrollTop from '@/components/LxScrollTop/index'
// import LxHeader from './components/LxHeader/One'
import Home from '@/pages/Home'
import MechanismList from '@/pages/Mobile/MechanismList'
import LxTransition from '@/components/LxTransition'
// import Router from '@/router'

function App() {
  return (
    <LxScrollTop>
      {/* <LxHeader></LxHeader> */}
      <LxTransition>
        {/* <Router /> */}
        <Route path='/campus' component={MechanismList}/>
        <Route path='/' component={Home}/>
        <Redirect from="/*" to="/"></Redirect>
      </LxTransition>
    </LxScrollTop>
  );
}

export default App;